<form #jobcheckForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/jobchecklist']">Job Check List</a> > {{ jobchecklist.description || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(jobcheckForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Description</mat-label>
            <input #des="ngModel" type="text" matInput name="description" [(ngModel)]="jobchecklist.description" required>
            <mat-error *ngIf="des.invalid && des.touched">Description is required</mat-error>
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="jobchecklist" [recordId]="jobchecklist.id"></app-audit-log-viewer>
</form>
